import { ActionReducer } from '@ngrx/store';
import { State } from '..';
import * as fromUser from '../../fromUser.barrel';
import * as fromClosures from '../../fromClosures.barrel';
import * as fromFittings from '../../fromFittings.barrel';
import * as fromPigs from '../../fromPigs.barrel';
import * as fromErrors from '../../reducers/errors.reducer';
import * as fromSearch from '../../fromSearch.barrel';
import * as fromAdmin from '../admin';
import * as fromMessages from '../../fromMessages.barrel';
import * as fromGuide from '../../fromPigProductGuide.barrel';
import * as fromPE from '../../fromPe.barrel';
import * as fromPigSig from '../../fromPigSig.barrel';
import * as fromSealingElement from '../../fromSealingElement.barrel';
import * as fromSealingElementMaintenance from '../../reducers/sealing-element-maintenance.reducer';
import * as fromEquipment from '../../fromEquipment.barrel';
import * as fromORings from '../../fromORing.barrel';

export function clearStateOnLogout(reducer: ActionReducer<State>): ActionReducer<State> {

  return (state, action) => {
    if (!!action.type && action.type === fromUser.logout.type) {
      return reducer({
        ...state,
        userProfile: fromUser.initialState,
        closures: fromClosures.initialState,
        fittings: fromFittings.initialState,
        pig: fromPigs.initialState,
        pigProductGuide: fromGuide.initialState,
        search: fromSearch.initialState,
        errors: fromErrors.initialState,
        router: {
          state: { url: '/', params: {} },
          navigationId: -1,
        },
        admin: fromAdmin.initialState,
        messages: fromMessages.initialState,
        pe: fromPE.initialState,
        pigSig: fromPigSig.initialState,
        sealingElements: fromSealingElement.initialState,
        sealingElementMaintenance: fromSealingElementMaintenance.initialState,
        equipment: fromEquipment.initialState,
        orings: fromORings.initialState
      }, action);
    }
    return reducer(state, action);
  };
}
